import { getAppConfig } from '@/app/config';
import parsePhoneNumberFromString, { type CountryCode } from 'libphonenumber-js';

export function isError(errors: Array<string | Error> | undefined | null) {
  return Array.isArray(errors) && errors.length > 0;
}

export function generateRegisterAbsoluteUrl(relativePath: string): string {
  const appConfig = getAppConfig();
  return appConfig.host + '/' + relativePath.replace(/^\/|\/$/g, '');
}

export function validatePhoneNumber({ phone, country }: { phone: string, country: CountryCode }): boolean {
  const phoneNumber = parsePhoneNumberFromString(phone, country);
  return phoneNumber?.isValid() ?? false;
}
